import { field, scope, vector } from '../instructions';
var unitInfo = function (width) {
    return scope(width, width, [
        vector('unitPattern', ['plural-key', 'unit-id']),
        vector('displayName', ['unit-id']),
        vector('perUnitPattern', ['unit-id']),
        field('perPattern'),
        field('timesPattern'),
    ]);
};
export var UNITS = scope('Units', 'Units', [unitInfo('long'), unitInfo('narrow'), unitInfo('short')]);
//# sourceMappingURL=units.js.map